import React, { Component } from 'react';
import './Contact.css';
import DarkModeToggle from '../Dark/DarkModeToggle';
import '../Dark/styles.scss';
class Contact extends Component {
  render() {
    return (
      <section id="contact">
      <div className="Title">CONTACT </div>
      
        <div className="con">
        <div className="contact" >
            <div className="add">
                <h3>Address</h3>
                <div className="addre">
                    <span>Mohammad Zaryab</span> <br />
                    <span>IIT Roorkee</span> <br />
                    <span>Roorkee, 247667</span> <br />
                    <span>Uttarakhand</span> <br />
                </div>
            </div>

            <div className="conn">
                <h3>Let's Connect!</h3>
                <div className="sites">
                      <div>

                          <a className="fa fa-facebook" href="https://www.facebook.com/zaryab.mohammad.37201/"> <span className="s">Facebook</span>  </a><br />
                          <a className="fa fa-envelope" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=mohammadzaryab0@gmail.com"><span className="s">Gmail</span>  </a><br />
                          <a className="fa fa-github" href="http://github.com/mohdzaryab"><span className="s">Github</span>   </a> <br />
                      </div>
                      <div>
                      <a className="fa fa-linkedin" href="https://www.linkedin.com/in/mohammad-zaryab-52a190173/" ><span className="s">LinkedIn</span>  </a><br />
                      <a className="fa fa-instagram" href="http://instagram.com/mohdzaryab/"><span className="s">Instagram</span>  </a><br />

                      <a className="fa fa-phone" href="tel: +917017431872"> <span className="s">7017431872</span> </a> <br/>
                      </div>
                </div>
            </div>
            
      </div>
      <div className="tag">Looking forward to create Amazing User Experiences!</div>
      </div>
      
      <div className="footer">MOHAMMAD ZARYAB © 2022</div>
        </section>
    );
  }
}

export default Contact;